// extracted by mini-css-extract-plugin
module.exports = {"root":"PrivacyNotification_root__qU1vM","fullScreenView":"PrivacyNotification_fullScreenView__oUBx5"};